import { DwNotification } from 'src/components/dw-notification';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DwNotification.displayName, DwNotification);

export default DwNotification;
export { DwNotification };
